export interface WebPushSendStats {
  delivered: number;
  failed: number;
  expired: number;
}

export function toSafeNonNegativeInt(value: unknown, fallback = 0): number {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return fallback;
  }

  const normalized = Math.floor(value);
  return normalized >= 0 ? normalized : fallback;
}

export function normalizeWebPushSendStats(rawStats: unknown): WebPushSendStats {
  if (!rawStats || typeof rawStats !== "object") {
    throw new Error("Некорректный ответ сервера при отправке тестового Web Push");
  }

  const statsSource = rawStats as {
    delivered?: unknown;
    failed?: unknown;
    expired?: unknown;
  };

  return {
    delivered: toSafeNonNegativeInt(statsSource.delivered, 0),
    failed: toSafeNonNegativeInt(statsSource.failed, 0),
    expired: toSafeNonNegativeInt(statsSource.expired, 0),
  };
}

export function base64UrlToArrayBuffer(value: string): ArrayBuffer {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const remainder = normalized.length % 4;
  const padded =
    remainder === 0 ? normalized : `${normalized}${"=".repeat(4 - remainder)}`;
  const raw = atob(padded);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) {
    output[i] = raw.charCodeAt(i);
  }
  return output.buffer.slice(
    output.byteOffset,
    output.byteOffset + output.byteLength,
  );
}

export function toBase64Url(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.length; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
}

export function isPushSubscriptionBoundToKey(
  subscription: PushSubscription,
  publicKey: string,
): boolean {
  const key = subscription.options.applicationServerKey;
  if (!key) {
    return false;
  }

  const keyBytes = new Uint8Array(key);
  return toBase64Url(keyBytes) === publicKey;
}
